interface StringObject {
    [k: string]: string;
};

export interface MessageProps {
    type: string;
    title?: string;
    text?: string;
    icon?: any;
    link?: {text: string; url: string; idForHidding?: string};
};

export interface ServiceMessage {
    id: string;
    type: string;
    contexts: string | string[];
    icon?: string;
    app?: string;
    title?: string | StringObject;
    text?: string | StringObject;
    linkText?: string | StringObject;
    link?: string;
    hideMessageAfterLinkClicked?: boolean;
};

export const convertServiceMessageToAppMessage = (serviceMessage?: ServiceMessage | ServiceMessage[], context?: string | string[]): MessageProps[] => {
    const output: MessageProps[] = [];
    const messageList = (serviceMessage instanceof Array ? serviceMessage : [serviceMessage]).filter( (d?: ServiceMessage) => !!d);
    const contextList = (context instanceof Array ? context : (context || '').split(',')).filter( (d: string) => !!d)
    const contextPin: StringObject = contextList.reduce( (pin: StringObject, text: string) => {
        pin[text] = '1';
        return pin;
    }, {'ALL': '1'});

    const getText = ( text?: string | StringObject ): string => {
        if ( !text ) { return ''; }

        const out = typeof(text) === 'string' ? text : ((text || {}).NO || '');
        return out.trim();
    };

    messageList.forEach( (data?: ServiceMessage): void => {
        if ( !data ) { return; }

        const place = data.contexts || '';
        const isSamePlace = (place instanceof Array ? place : place.split(',')).find( (name: string) => {
            return !!contextPin[name.trim()];
        });

        if ( !isSamePlace ) { return; }

        const linkText = getText(data.linkText);
        output.push({
            type: (data.type || 'info').toLowerCase(),
            title: getText( data.title ),
            text: getText(data.text),
            icon: data.icon,
            link: linkText && data.link ?
                { text: linkText, url: data.link, idForHidding: data.hideMessageAfterLinkClicked ? data.id : '' } : undefined,
        });
    });

    return output;
}

